import type { ReactNode } from 'react';
import { cx } from '../components/idsk';

/** The single h1 of a page (focus target after route changes). Optional caption above (e.g. "Krok 2 z 4"). */
export function PageHeading({ children, caption, size = 'l', className }: { children: ReactNode; caption?: ReactNode; size?: 'xl' | 'l' | 'm'; className?: string }) {
  return (
    <>
      {caption && <span className={`govuk-caption-${size === 'm' ? 'm' : 'l'}`}>{caption}</span>}
      <h1 className={cx(`govuk-heading-${size}`, className)} tabIndex={-1}>
        {children}
      </h1>
    </>
  );
}
